import React, {
    useEffect,
    useState,
    useRef,
} from 'react';
import {
    Paper,
    Typography,
    makeStyles,
    CardActionArea,
    CircularProgress
} from '@material-ui/core';
import Placeholder from '../Common/Images/placeholder.jpg'
import Image from 'material-ui-image'
import {placeholder} from "@babel/types";

const FeedListItemLink = (props: any) => {
    const {url} = props;
    const classes = useStyles();
    const [metaData, setMetaData] = useState<any>();
    const imageRef = useRef();
    const controller: AbortController = new AbortController();
    const signal = controller.signal;
    const getMetaData = async (url: string) => {

        url = secureHttp(url);
        try {
            const res = await fetch(`https://jaspercardws2.manhattan.edu:9443/meta?url=${url}`, {signal});
            const json = await res.json();
            if (setMetaData) {
                if (!json.error) {
                    setMetaData(json)
                } else {
                    setMetaData({error: true})
                }
            }
        } catch (error) {
            // console.log(error)
            if (setMetaData) {
                setMetaData({error: true})
            }

        }

    };

    const secureHttp = (url: string) => {
        if (!url.includes('https')) {
            return url.replace('http', 'https')
        } else {
            return url
        }
    };

    const getLinkImage = (metaData: any) => {
       switch(true) {
           case metaData.site.logo != undefined:
               return metaData.site.logo;
           case metaData.site.favicon != undefined:
               return metaData.site.favicon;
           default:
               return Placeholder
       }
    };




    useEffect( () => {

        getMetaData(url)
        return () => {
            if (imageRef.current) {
                imageRef.current.src = '';
            }
            controller.abort();

        }
        }, []);

    useEffect(() => {
        return () => {
            controller.abort();
            if (imageRef.current) {
                imageRef.current.src = '';
            }
        }
    })
    return (
        <>

        <Paper variant={'outlined'} className={classes.root}>
            {!metaData  &&
                <CircularProgress className={classes.progress} />
           }
            {metaData && metaData.error &&
                <Typography className={classes.error}>
                    Embedded Link Not Available
                </Typography>
            }
            {metaData && !metaData.error && (metaData.title != undefined || metaData.description != undefined) &&
            <CardActionArea
                className={classes.actionArea}
                onClick={() => {
                    if (window.webkit) {
                        // @ts-ignore
                        window.webkit.messageHandlers.url.postMessage(
                            {
                                url: secureHttp(url),
                                refresh: false
                            })
                    } else {
                        window.open(secureHttp(url))
                    }
                }
                }>
                <Image
                    ref={(ref: any) => imageRef.current = ref}
                    src={secureHttp(getLinkImage(metaData))}
                    style={{
                        padding: 0,
                        height: '100%',
                        width: 64,
                    }}
                    imageStyle={{height: 64, width: 64, position: 'relative'}}
                    disableSpinner={true}
                    errorIcon={ <img className={classes.image} src={Placeholder}/>}
                />

                <div
                    className={classes.details}
                >


                    <Typography variant={'subtitle2'} className={classes.title}>
                        {(metaData.title != '' ? metaData.title : metaData.site.name) || 'Embedded Link to Site' }
                    </Typography>
                    <Typography variant={'caption'} className={classes.subTitle}>
                        {metaData.description || ''}
                    </Typography>

                </div>
            </CardActionArea>}
        </Paper>
</>
    )
};

const useStyles = makeStyles({
    image: {
        height: 64,
        width: 64,
        // display: 'flex'
    },
    details: {
        flex: 1,
        height: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: 8
    },
    actionArea: {
        display: 'flex',
        flexDirection: 'row',
        overflow: 'hidden',
        height: '100%'
    },
    root: {
       height: 64,
        overflow: 'hidden'

    },
    title: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        fontWeight: 'bold'
    },
    subTitle: {
        whiteSpace: 'nowrap'
    },
    loadingBox: {
        height: 64,
        width: '100%',
    },
    progress: {
        position: 'relative',
        left: '50%',
        transform: 'translate(-50%, 0)'
    },
    error: {
        position: 'relative',
        top: '50%',
        transform: 'translate(0, -50%)',
        textAlign: 'center'


    }
});

export default FeedListItemLink